/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { BenefitActivationDTO } from './benefit-activation-dto';
import { CouponGiftPayoutDateWithActiveInviteDTO } from './coupon-gift-payout-date-with-active-invite-dto';
import { EmployeeDTOActiveBenefitTemplate } from './employee-dtoactive-benefit-template';
import { UserDTO } from './user-dto';

/**
 * 
 * @export
 * @interface EmployeeDTO
 */
export interface EmployeeDTO {
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'salutation'?: EmployeeDTOSalutationEnum;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'status': EmployeeDTOStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeDTO
     */
    'roles': Array<EmployeeDTORolesEnum>;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'employeeType'?: EmployeeDTOEmployeeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'source': EmployeeDTOSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'civilStatus'?: EmployeeDTOCivilStatusEnum;
    /**
     * The country of the user\'s home address in ISO31661Alpha2 format
     * @type {string}
     * @memberof EmployeeDTO
     */
    'homeAddressCountry'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'legalTermsAction'?: EmployeeDTOLegalTermsActionEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeDTO
     */
    'requiredActions': Array<EmployeeDTORequiredActionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'preferredPortal': EmployeeDTOPreferredPortalEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeDTO
     */
    'activeBenefits'?: Array<EmployeeDTOActiveBenefitsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeDTO
     */
    'upcomingBenefits'?: Array<EmployeeDTOUpcomingBenefitsEnum>;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     * @deprecated
     */
    'registrationToken'?: string;
    /**
     * 
     * @type {UserDTO}
     * @memberof EmployeeDTO
     */
    'user'?: UserDTO;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeDTO
     */
    'activeCustomBenefits'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeDTO
     */
    'upcomingCustomBenefits'?: Array<string>;
    /**
     * 
     * @type {BenefitActivationDTO}
     * @memberof EmployeeDTO
     */
    'benefitActivation'?: BenefitActivationDTO;
    /**
     * 
     * @type {EmployeeDTOActiveBenefitTemplate}
     * @memberof EmployeeDTO
     */
    'activeBenefitTemplate'?: EmployeeDTOActiveBenefitTemplate;
    /**
     * 
     * @type {EmployeeDTOActiveBenefitTemplate}
     * @memberof EmployeeDTO
     */
    'upcomingBenefitTemplate'?: EmployeeDTOActiveBenefitTemplate;
    /**
     * 
     * @type {CouponGiftPayoutDateWithActiveInviteDTO}
     * @memberof EmployeeDTO
     */
    'nextGift'?: CouponGiftPayoutDateWithActiveInviteDTO;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'newsArticleStatus'?: EmployeeDTONewsArticleStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'registrationCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'expiryDateRegistrationCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'invitationMailSentAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'bikeleasingCrmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'accountServiceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'tenantId': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'tenantName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'mail'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'employeeNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'birthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'hireDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'terminationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'department'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeDTO
     */
    'workLocations': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'costCenter'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'defaultCouponId'?: string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeDTO
     */
    'receiptCred'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeDTO
     */
    'bavNotInterested'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EmployeeDTO
     */
    'numberOfKids'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeDTO
     */
    'isSyncedFromHRSystem'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'homeAddressStreet'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'homeAddressStreetLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'homeAddressPostalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'homeAddressCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'homeAddressRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'legalTermsLastConsentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'hrSystemBenefitTemplateId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeDTO
     */
    'mailDeliveryError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDTO
     */
    'bikeleasingEmployeeCode'?: string;
}

export const EmployeeDTOSalutationEnum = {
    Mr: 'MR',
    Ms: 'MS',
    Divers: 'DIVERS'
} as const;

export type EmployeeDTOSalutationEnum = typeof EmployeeDTOSalutationEnum[keyof typeof EmployeeDTOSalutationEnum];
export const EmployeeDTOStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Registered: 'REGISTERED',
    Deleted: 'DELETED'
} as const;

export type EmployeeDTOStatusEnum = typeof EmployeeDTOStatusEnum[keyof typeof EmployeeDTOStatusEnum];
export const EmployeeDTORolesEnum = {
    TenantAdmin: 'TENANT_ADMIN',
    TenantAssistant: 'TENANT_ASSISTANT',
    User: 'USER',
    TenantSales: 'TENANT_SALES'
} as const;

export type EmployeeDTORolesEnum = typeof EmployeeDTORolesEnum[keyof typeof EmployeeDTORolesEnum];
export const EmployeeDTOEmployeeTypeEnum = {
    FullTime: 'FULL_TIME',
    PartTime: 'PART_TIME',
    Intern: 'INTERN',
    Student: 'STUDENT',
    MiniJob: 'MINI_JOB',
    Apprenticeship: 'APPRENTICESHIP',
    Training: 'TRAINING',
    External: 'EXTERNAL',
    Misc: 'MISC'
} as const;

export type EmployeeDTOEmployeeTypeEnum = typeof EmployeeDTOEmployeeTypeEnum[keyof typeof EmployeeDTOEmployeeTypeEnum];
export const EmployeeDTOSourceEnum = {
    Probonio: 'Probonio',
    Bikeleasing: 'Bikeleasing',
    Import: 'Import'
} as const;

export type EmployeeDTOSourceEnum = typeof EmployeeDTOSourceEnum[keyof typeof EmployeeDTOSourceEnum];
export const EmployeeDTOCivilStatusEnum = {
    Single: 'SINGLE',
    Married: 'MARRIED',
    Divorced: 'DIVORCED',
    Widowed: 'WIDOWED',
    CivilUnion: 'CIVIL_UNION',
    CivilUnionDeceased: 'CIVIL_UNION_DECEASED',
    CivilUnionCancelled: 'CIVIL_UNION_CANCELLED'
} as const;

export type EmployeeDTOCivilStatusEnum = typeof EmployeeDTOCivilStatusEnum[keyof typeof EmployeeDTOCivilStatusEnum];
export const EmployeeDTOLegalTermsActionEnum = {
    None: 'NONE',
    Skip: 'SKIP',
    Consent: 'CONSENT'
} as const;

export type EmployeeDTOLegalTermsActionEnum = typeof EmployeeDTOLegalTermsActionEnum[keyof typeof EmployeeDTOLegalTermsActionEnum];
export const EmployeeDTORequiredActionsEnum = {
    UpdateProfile: 'UpdateProfile'
} as const;

export type EmployeeDTORequiredActionsEnum = typeof EmployeeDTORequiredActionsEnum[keyof typeof EmployeeDTORequiredActionsEnum];
export const EmployeeDTOPreferredPortalEnum = {
    Bikeleasing: 'BIKELEASING',
    OnePortal: 'ONE_PORTAL',
    Neutral: 'NEUTRAL'
} as const;

export type EmployeeDTOPreferredPortalEnum = typeof EmployeeDTOPreferredPortalEnum[keyof typeof EmployeeDTOPreferredPortalEnum];
export const EmployeeDTOActiveBenefitsEnum = {
    Bav: 'BAV',
    Lunch: 'LUNCH',
    Coupons: 'COUPONS',
    CouponsV2: 'COUPONS_V2',
    Mobility: 'MOBILITY',
    Gifts: 'GIFTS',
    Internet: 'INTERNET',
    Bike: 'BIKE',
    News: 'NEWS',
    Flex: 'FLEX',
    Recreation: 'RECREATION',
    Bikeleasing: 'BIKELEASING',
    BikeleasingV2: 'BIKELEASING_V2',
    Fitness: 'FITNESS',
    Kita: 'KITA',
    CreditCard: 'CREDIT_CARD',
    DiscountCode: 'DISCOUNT_CODE',
    Custom: 'CUSTOM',
    AtLunch: 'AT_LUNCH',
    AtMobility: 'AT_MOBILITY',
    Car: 'CAR',
    ItLeasing: 'IT_LEASING',
    Wellpass: 'WELLPASS'
} as const;

export type EmployeeDTOActiveBenefitsEnum = typeof EmployeeDTOActiveBenefitsEnum[keyof typeof EmployeeDTOActiveBenefitsEnum];
export const EmployeeDTOUpcomingBenefitsEnum = {
    Bav: 'BAV',
    Lunch: 'LUNCH',
    Coupons: 'COUPONS',
    CouponsV2: 'COUPONS_V2',
    Mobility: 'MOBILITY',
    Gifts: 'GIFTS',
    Internet: 'INTERNET',
    Bike: 'BIKE',
    News: 'NEWS',
    Flex: 'FLEX',
    Recreation: 'RECREATION',
    Bikeleasing: 'BIKELEASING',
    BikeleasingV2: 'BIKELEASING_V2',
    Fitness: 'FITNESS',
    Kita: 'KITA',
    CreditCard: 'CREDIT_CARD',
    DiscountCode: 'DISCOUNT_CODE',
    Custom: 'CUSTOM',
    AtLunch: 'AT_LUNCH',
    AtMobility: 'AT_MOBILITY',
    Car: 'CAR',
    ItLeasing: 'IT_LEASING',
    Wellpass: 'WELLPASS'
} as const;

export type EmployeeDTOUpcomingBenefitsEnum = typeof EmployeeDTOUpcomingBenefitsEnum[keyof typeof EmployeeDTOUpcomingBenefitsEnum];
export const EmployeeDTONewsArticleStatusEnum = {
    Seen: 'SEEN',
    ConfirmedSeen: 'CONFIRMED_SEEN'
} as const;

export type EmployeeDTONewsArticleStatusEnum = typeof EmployeeDTONewsArticleStatusEnum[keyof typeof EmployeeDTONewsArticleStatusEnum];


